import styled from 'styled-components';
import { colorsV2 } from '../../../../colors-v2';

export const BorderShadingMain = styled.div<{ $bgColor?: string; $borderColor?: string }>`
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : colorsV2.yellow5)};
  border: 1px solid ${(props) => (props.$borderColor ? props.$borderColor : colorsV2.yellow20)};
  border-radius: 8px;
  padding: 24px 32px;
  margin-bottom: 1em;

  > p,
  ul {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
